import React, { useEffect } from 'react';
import axios from 'axios';

const OneDrivePicker = ({ files_send_to_parent }) => {
  const clientId = '8e826455-48a0-44a2-aedd-3034cabc6131';


  const redirectUri = process.env.NODE_ENV === 'production'
    ? 'https://onboarding.maybetech.com/file-upload'
    : 'http://localhost:4042/app/setting';// Replace with your actual redirect URI

  // Load OneDrive script dynamically
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://js.live.net/v7.2/OneDrive.js';
    script.onload = () => console.log('OneDrive SDK loaded');
    script.onerror = () => console.error('Failed to load OneDrive SDK');
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script); // Clean up when component unmounts
    };
  }, []);

  // Download file from OneDrive link
  const downloadFile = async (file) => {
    try {
      const response = await axios.get(file['@microsoft.graph.downloadUrl'], {
        responseType: 'blob',
      });

      const blob = response.data;
      const fileName = file.name || 'downloaded-file';
      return new File([blob], fileName, { type: blob.type });
    } catch (error) {
      console.error('Error downloading file:', error);
      return null;
    }
  };

  // Select and download the files from OneDrive
  const selectFile = async (file) => {
    const downloadedFile = await downloadFile(file);
    if (downloadedFile) {
      files_send_to_parent(downloadedFile); // Send the file to the parent component
    } else {
      console.error('Failed to download the selected file.');
    }
  };

  // Open OneDrive Picker
  const handleOneDriveClick = () => {
    if (!window.OneDrive) {
      console.error('OneDrive SDK is not loaded.');
      return;
    }

    try {
      const odOptions = {
        clientId: clientId,
        action: 'download',
        multiSelect: true,
        openInNewWindow: true,
        advanced: {
          filter: ['.pdf', '.doc', '.docx', '.txt', '.csv', '.json', '.html'],
        },
        success: async (files) => {
          for (const file of files.value) {
            selectFile(file)
          }
        },
        cancel: () => {
          console.log('OneDrive picker was closed without selecting files.');
        },
        error: (error) => {
          console.error('OneDrive picker error:', error);
        }
      };

      window.OneDrive.open(odOptions);
    } catch (error) {
      console.error('Error occurred while opening OneDrive picker:', error);
    }
  };

  return (
    <div>
      <button onClick={handleOneDriveClick}>Connect OneDrive</button>
    </div>
  );
};

export default OneDrivePicker;
